import { VARS_STORE_KEY } from '../constants';
import type { State } from '../reducers/varsReducers';

export default (state: GlobalState) => (state[VARS_STORE_KEY] || {}) as State | undefined;
